// Create Lookbook
export const CREATE_LOOKBOOK_REQUEST = 'CREATE_LOOKBOOK_REQUEST';
export const CREATE_LOOKBOOK_DONE = 'CREATE_LOOKBOOK_DONE';
export const CREATE_LOOKBOOK_FAILED = 'CREATE_LOOKBOOK_FAILED';
export const CREATE_LOOKBOOK_RESET = 'CREATE_LOOKBOOK_RESET';